export const categories = [
  {
    slug: 'riyong-baihuo',
    name: '日用百货',
    icon: 'ri-home-smile-line',
    description: '家居清洁、收纳整理、日常消耗品等国货好物推荐',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20Chinese%20household%20daily%20essentials%20display%20on%20wooden%20table%2C%20clean%20cream%20background%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20organic%20composition%2C%20harmonious%20warm%20tones&width=800&height=600&seq=cat-daily-01&orientation=landscape',
  },
  {
    slug: 'keji-dianzi',
    name: '科技电子',
    icon: 'ri-smartphone-line',
    description: '国产手机、智能穿戴、耳机音响、数码配件精选推荐',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20gadgets%20including%20smartphone%20and%20earbuds%20on%20minimalist%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20editorial%20style%20product%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-tech-01&orientation=landscape',
  },
  {
    slug: 'meishi-yinpin',
    name: '美食饮品',
    icon: 'ri-restaurant-line',
    description: '地方特产、零食小吃、茶饮酒水，地道中国味',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20snacks%20and%20tea%20arranged%20beautifully%20on%20wooden%20board%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20food%20photography%2C%20elegant%20composition&width=800&height=600&seq=cat-food-01&orientation=landscape',
  },
  {
    slug: 'fushi-xiebao',
    name: '服饰鞋包',
    icon: 'ri-t-shirt-line',
    description: '国潮品牌、运动鞋服、箱包皮具，穿出中国范儿',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20brand%20clothing%20and%20accessories%20displayed%20on%20minimalist%20rack%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20editorial%20fashion%20photography%2C%20clean%20elegant%20style&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
  },
  {
    slug: 'meirong-hufu',
    name: '美妆护肤',
    icon: 'ri-magic-line',
    description: '国货护肤品、彩妆、个人护理，东方美学焕发光彩',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20skincare%20and%20cosmetic%20products%20arranged%20elegantly%20on%20marble%20surface%2C%20warm%20cream%20background%2C%20soft%20diffused%20light%2C%20editorial%20beauty%20photography%2C%20minimalist%20composition&width=800&height=600&seq=cat-beauty-01&orientation=landscape',
  },
  {
    slug: 'jiaju-jiazhuang',
    name: '家居家装',
    icon: 'ri-building-2-line',
    description: '家具、灯具、家纺、厨具，打造温馨中式家居',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20style%20home%20decor%20and%20furniture%20in%20bright%20living%20room%2C%20warm%20cream%20walls%2C%20natural%20light%2C%20editorial%20interior%20photography%2C%20minimalist%20elegant%20design&width=800&height=600&seq=cat-home-01&orientation=landscape',
  },
];

export const featuredProducts = [
  {
    id: 1,
    name: '华为 Mate 70 Pro',
    brand: '华为',
    category: 'keji-dianzi',
    categoryName: '科技电子',
    price: '¥6,999',
    rating: 4.9,
    reviews: 12856,
    image: 'https://readdy.ai/api/search-image?query=Huawei%20Mate%2070%20Pro%20smartphone%20on%20minimalist%20white%20surface%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20product%20photography%2C%20clean%20elegant%20composition&width=600&height=600&seq=prod-huawei-01&orientation=squarish',
    badge: '编辑推荐',
    description: '国产旗舰手机标杆，搭载麒麟芯片与鸿蒙系统，性能影像全面领先。',
  },
  {
    id: 2,
    name: '大疆 DJI Pocket 3',
    brand: '大疆',
    category: 'keji-dianzi',
    categoryName: '科技电子',
    price: '¥3,499',
    rating: 4.8,
    reviews: 8923,
    image: 'https://readdy.ai/api/search-image?query=DJI%20Pocket%203%20compact%20camera%20gimbal%20on%20clean%20white%20surface%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20product%20photography%2C%20minimalist%20composition&width=600&height=600&seq=prod-dji-01&orientation=squarish',
    badge: '口碑之选',
    description: '口袋云台相机，一英寸传感器，随时随地记录生活精彩瞬间。',
  },
  {
    id: 3,
    name: '安踏 C37 4.0 跑鞋',
    brand: '安踏',
    category: 'fushi-xiebao',
    categoryName: '服饰鞋包',
    price: '¥499',
    rating: 4.7,
    reviews: 25680,
    image: 'https://readdy.ai/api/search-image?query=ANTA%20C37%20running%20shoes%20on%20minimalist%20white%20surface%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20product%20photography%2C%20clean%20sporty%20style&width=600&height=600&seq=prod-anta-01&orientation=squarish',
    badge: '热销爆款',
    description: '氮科技中底，超轻透气鞋面，国产跑鞋的性价比天花板。',
  },
  {
    id: 4,
    name: '花西子空气蜜粉',
    brand: '花西子',
    category: 'meirong-hufu',
    categoryName: '美妆护肤',
    price: '¥199',
    rating: 4.8,
    reviews: 35600,
    image: 'https://readdy.ai/api/search-image?query=Huaxizi%20loose%20powder%20compact%20with%20Chinese%20carved%20design%20on%20clean%20surface%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20product%20photography%2C%20elegant%20composition&width=600&height=600&seq=prod-huaxizi-01&orientation=squarish',
    badge: '国货之光',
    description: '东方美学雕花设计，细腻轻盈定妆，控油持妆一整天。',
  },
  {
    id: 5,
    name: '三顿半精品速溶咖啡',
    brand: '三顿半',
    category: 'meishi-yinpin',
    categoryName: '美食饮品',
    price: '¥189',
    rating: 4.7,
    reviews: 18900,
    image: 'https://readdy.ai/api/search-image?query=Saturnbird%20instant%20coffee%20small%20cups%20arranged%20on%20wooden%20surface%2C%20cream%20background%2C%20warm%20natural%20lighting%2C%20product%20photography%2C%20minimalist%20style&width=600&height=600&seq=prod-saturn-01&orientation=squarish',
    badge: '新锐品牌',
    description: '精品速溶咖啡开创者，小罐设计，随时随地享受好咖啡。',
  },
  {
    id: 6,
    name: '小米智能扫地机器人',
    brand: '小米',
    category: 'riyong-baihuo',
    categoryName: '日用百货',
    price: '¥1,999',
    rating: 4.6,
    reviews: 45200,
    image: 'https://readdy.ai/api/search-image?query=Xiaomi%20robot%20vacuum%20cleaner%20on%20clean%20wooden%20floor%2C%20cream%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20minimalist%20tech%20style&width=600&height=600&seq=prod-xiaomi-01&orientation=squarish',
    badge: '智能好物',
    description: 'LDS激光导航，扫拖一体，智能家居入门首选。',
  },
  {
    id: 7,
    name: '云南古树普洱生茶',
    brand: '大益',
    category: 'meishi-yinpin',
    categoryName: '美食饮品',
    price: '¥368',
    rating: 4.9,
    reviews: 6700,
    image: 'https://readdy.ai/api/search-image?query=Yunnan%20ancient%20tree%20Pu%20erh%20tea%20cake%20on%20wooden%20tea%20tray%20with%20teacup%2C%20cream%20background%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20traditional%20Chinese%20tea%20aesthetic&width=600&height=600&seq=prod-puer-01&orientation=squarish',
    badge: '匠心之作',
    description: '云南勐海古树原料，传统工艺压制，回甘悠长。',
  },
  {
    id: 8,
    name: '网易严选乳胶枕',
    brand: '网易严选',
    category: 'jiaju-jiazhuang',
    categoryName: '家居家装',
    price: '¥259',
    rating: 4.7,
    reviews: 28900,
    image: 'https://readdy.ai/api/search-image?query=Natural%20latex%20pillow%20on%20minimalist%20bed%20with%20white%20linen%2C%20cream%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20cozy%20bedroom%20style&width=600&height=600&seq=prod-pillow-01&orientation=squarish',
    badge: '睡眠好物',
    description: '天然泰国乳胶，人体工学曲线设计，一夜好眠的秘诀。',
  },
];

export const brands = [
  {
    name: '华为',
    logo: 'https://readdy.ai/api/search-image?query=Huawei%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20clean%20design&width=200&height=200&seq=brand-huawei-01&orientation=squarish',
    description: '全球领先的ICT基础设施和智能终端提供商',
    productCount: 1200,
  },
  {
    name: '小米',
    logo: 'https://readdy.ai/api/search-image?query=Xiaomi%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20clean%20design&width=200&height=200&seq=brand-xiaomi-01&orientation=squarish',
    description: '让每个人都能享受科技的乐趣',
    productCount: 2800,
  },
  {
    name: '大疆',
    logo: 'https://readdy.ai/api/search-image?query=DJI%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20clean%20design&width=200&height=200&seq=brand-dji-01&orientation=squarish',
    description: '全球无人机和影像技术领导者',
    productCount: 560,
  },
  {
    name: '安踏',
    logo: 'https://readdy.ai/api/search-image?query=Anta%20Sports%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20clean%20design&width=200&height=200&seq=brand-anta-01&orientation=squarish',
    description: '中国领先的体育用品品牌，走向世界舞台',
    productCount: 3400,
  },
  {
    name: '花西子',
    logo: 'https://readdy.ai/api/search-image?query=Chinese%20cosmetic%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20oriental%20design&width=200&height=200&seq=brand-huaxizi-01&orientation=squarish',
    description: '以东方美学为核心的国货彩妆品牌',
    productCount: 380,
  },
  {
    name: '李宁',
    logo: 'https://readdy.ai/api/search-image?query=Li%20Ning%20sports%20brand%20logo%20style%20minimalist%20icon%20on%20cream%20background%2C%20clean%20design&width=200&height=200&seq=brand-lining-01&orientation=squarish',
    description: '中国领先体育品牌，国潮运动时尚引领者',
    productCount: 2800,
  },
];